import React from 'react'
import PropTypes from 'prop-types'

const LandingTotallyCustom = ({ block, onButtonClick }) => {
  const { className, title, content, button, buttonText, justifyButton, buttonColor = 'primary', buttonSize = 'sm' } = block

  return (
    <div className={`row align-items-center px-0 px-md-5 ${className}`}>
      <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 px-0 py-5 px-lg-5 d-flex flex-column flex-lg-row align-items-center'>
        <div className='col px-5 px-md-0 py-4'>

          {title && <p className=' h5 text-primary mb-3' data-cy='landing-info-title'><div dangerouslySetInnerHTML={{ __html: title }} /></p>}

          {content && <div data-cy='landing-info-description'><div dangerouslySetInnerHTML={{ __html: content }} /></div>}

          {button &&
            <div style={{ display: 'flex', justifyContent: justifyButton }}>
              <button className={`btn btn-${buttonSize} btn-${buttonColor} mt-2`} onClick={onButtonClick}>{buttonText}</button>
            </div>
          }

        </div>
      </div>
    </div>
  )
}

LandingTotallyCustom.propTypes = {
  block: PropTypes.object,
  onButtonClick: PropTypes.func
}

export default LandingTotallyCustom
